import { useContext, useMemo, useState } from "react";
import Grid from "@mui/material/Grid2";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { Box, Divider, styled } from "@mui/material";
import { WithGrow } from "@common/components/WithGrow";
import Overview from "./Overview";
import FilterBar, { MonitoringFilterType } from "./components/FilterBar";
import Metrics from "./Metrics";
import { GraphType } from "@services/monitoring/types";
import Device from "./Device";

const Frame = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginTop: theme.spacing(2),
  height: "100%",
  width: "100%",
}));

/**
 *
 * @TODO implement the filtering/view changes as part of 1526
 * There's some basic work down for that, just to make sure we're not implementing the tab twice, and can smoothly
 * work in parallel
 */

export enum MeetingFilterViews {
  Overview = "overview",
  Device = "device",
  Metric = "metric",
}

const MonitoringTab = () => {
  const [selected, setSelected] = useState<
    { view: MonitoringFilterType; filter: GraphType | string } | undefined
  >();

  const onFilterChange = (filter: FilterDefinition) => {
    if (filter)
      setSelected({
        view: filter.filterType as MonitoringFilterType,
        filter: filter.filterValue,
      });
    else setSelected(undefined);
  };
  const selectedView = useMemo(() => {
    switch (selected?.view) {
      case MeetingFilterViews.Metric:
        return <Metrics type={selected.filter as GraphType} />;
      case MeetingFilterViews.Device:
        return <Device deviceId={selected.filter} />;
      default:
        return <Overview />;
    }
  }, [selected]);

  return (
    <WithGrow
      direction="column"
      fixed={
        <Grid>
          <WithGrow
            direction="row"
            sx={{ alignItems: "center", py: 1 }}
            fixed={
              <Grid
                container
                direction="row"
                sx={{ width: "100%", alignItems: "center" }}
              ></Grid>
            }
          >
            <WithGrow direction="row-reverse" fixed={<Grid></Grid>}>
              <FilterBar onFilterChange={onFilterChange} />
            </WithGrow>
          </WithGrow>
          <Divider orientation="horizontal" />
        </Grid>
      }
    >
      {selectedView}
    </WithGrow>
  );
};
const Container = () => {
  const context = useContext(RoomsRealtimeContext);
  if (typeof context.detail === "undefined") return <></>;

  const detailCtx = { ...context.detail };
  return (
    <Frame ref={detailCtx.detailFrameRef}>
      <MonitoringTab />
    </Frame>
  );
};

export default Container;
